(function (window, document) {
  'use strict';

  try {
    if (window.top !== window.self) return;
  } catch (error) {
    return;
  }

  if (window.sfOpenAIAds && window.sfOpenAIAds.version) return;

  var config = window.__sfOpenAIAdsConfig || {};
  var currency = typeof config.currency === 'string' ? config.currency.toUpperCase() : '';
  var measurementAllowed = false;
  var initialEventsSent = false;
  var checkoutStartedSent = false;
  var pendingVerification = false;
  var pendingVerificationSequence = 0;
  var lastCheckoutClickAt = 0;
  var pendingAddKey = '_sf_oaiq_pending_add_v1';
  var pendingAddTtlMs = 120000;
  var cartQuantities = {};
  var consentEndpoint = typeof config.consentEndpoint === 'string' ? config.consentEndpoint : '';
  var consentAttribute = typeof config.consentAttribute === 'string'
    ? config.consentAttribute
    : '__openai_ads_consent_receipt';
  var cartUpdateUrl = typeof config.cartUpdateUrl === 'string' ? config.cartUpdateUrl : '/cart/update.js';
  var receiptSessionKey = '_sf_oaiq_consent_receipt_v1';
  var receiptSyncGeneration = 0;
  var receiptRequest = null;
  var receiptReady = false;
  var denialSynchronized = false;
  var receiptSyncTimer = null;
  var desiredConsentState = false;

  function toInteger(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) && Math.floor(number) === number ? number : fallback;
  }

  function positiveQuantity(value) {
    var quantity = toInteger(value, 1);
    return quantity > 0 ? quantity : 1;
  }

  function stringValue(value) {
    return value === null || typeof value === 'undefined' ? '' : String(value);
  }

  function boundedValue(value, maxLength) {
    var normalized = stringValue(value).trim();
    if (!normalized || normalized.length > maxLength || /[\u0000-\u001f\u007f]/.test(normalized)) return '';
    return normalized;
  }

  // Consent identity only: Shopify's Ajax Cart token can carry a terminal
  // ?key= secret that is not present in checkout/order webhooks. Keep the
  // full token untouched for Ajax Cart API calls and normalize only here.
  function normalizeCartTokenForConsent(value) {
    if (typeof value !== 'string' || !value || value.length > 4096 || /[\s\u0000-\u001f\u007f]/.test(value)) return '';
    var marker = '?key=';
    var markerIndex = value.indexOf(marker);
    if (markerIndex === -1) return value;
    if (markerIndex !== value.lastIndexOf(marker)) return '';
    var baseToken = value.slice(0, markerIndex);
    var keySuffix = value.slice(markerIndex + marker.length);
    if (!baseToken || !keySuffix || /[?&#]/.test(keySuffix) || /%(?![0-9a-f]{2})/i.test(keySuffix)) return '';
    return baseToken;
  }

  // Read provider cookies only after marketing consent; preserve opaque bytes.
  function opaqueReference(value) {
    if (typeof value !== 'string' || value.length > 1024 || !value.trim()) return '';
    for (var i = 0; i < value.length; i += 1) {
      var code = value.charCodeAt(i);
      if (code <= 31 || code === 127) return '';
    }
    return value;
  }

  function attributionFieldValue(field, value) {
    return field === 'oppref' || field === 'obref'
      ? opaqueReference(value) : boundedValue(value, attributionFields[field]);
  }

  function currentReference(name) {
    if (!measurementAllowed) return '';
    var query = opaqueReference(queryValue(name));
    if (query) return query;
    var stored = opaqueReference(currentAttribution && currentAttribution[name]);
    var cookie = opaqueReference(cookieValue('__' + name));
    return name === 'obref' ? cookie || stored : stored || cookie;
  }

  var lastReceiptReferences = '';
  var referenceWatchTimer = null;
  var referenceWatchAttempt = 0;

  function referenceSignature() {
    return JSON.stringify([currentReference('oppref'), currentReference('obref')]);
  }

  function watchPixelReferences() {
    if (!measurementAllowed || (window.Shopify && window.Shopify.designMode)) return;
    if (receiptReady && lastReceiptReferences !== referenceSignature()) receiptReady = false;
    syncConsentReceipt(true);
    if (referenceWatchTimer || referenceWatchAttempt >= 6) return;
    var delay = Math.pow(2, referenceWatchAttempt++) * 1000;
    referenceWatchTimer = window.setTimeout(function () {
      referenceWatchTimer = null;
      watchPixelReferences();
    }, delay);
  }

  function stopReferenceWatch() {
    if (referenceWatchTimer) window.clearTimeout(referenceWatchTimer);
    referenceWatchTimer = null;
    referenceWatchAttempt = 0;
    lastReceiptReferences = '';
  }

  var attributionStorageKey = '__openai_ads_attribution_v1';
  var attributionTtlMs = 30 * 24 * 60 * 60 * 1000;
  var attributionFields = {
    oppref: 1024,
    obref: 1024,
    utm_source: 128,
    utm_medium: 128,
    utm_campaign: 256,
    utm_content: 256,
    openai_ad_group_id: 256,
    openai_ad_account_id: 256
  };
  var cartAttributionFields = {
    utm_source: '__openai_ads_utm_source',
    utm_medium: '__openai_ads_utm_medium',
    utm_campaign: '__openai_ads_utm_campaign',
    utm_content: '__openai_ads_utm_content',
    openai_ad_group_id: '__openai_ads_ad_group_id',
    openai_ad_account_id: '__openai_ads_ad_account_id'
  };
  var consentObservationMethod = 'stored_explicit_grant';

  function parseStoredAttribution(nowMs) {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(attributionStorageKey) || 'null');
      if (!parsed || typeof parsed !== 'object' || !Number.isSafeInteger(parsed.capturedAt) ||
          parsed.capturedAt > nowMs + 300000 || nowMs - parsed.capturedAt > attributionTtlMs) return null;
      var values = { capturedAt: parsed.capturedAt };
      Object.keys(attributionFields).forEach(function (field) {
        var value = attributionFieldValue(field, parsed[field]);
        if (value) values[field] = value;
      });
      return values;
    } catch (error) {
      return null;
    }
  }

  function captureAttribution() {
    var nowMs = Date.now();
    var current = parseStoredAttribution(nowMs);
    try {
      var params = new window.URL(window.location.href).searchParams;
      var candidate = { capturedAt: nowMs };
      Object.keys(attributionFields).forEach(function (field) {
        var value = attributionFieldValue(field, params.get(field));
        if (value) candidate[field] = value;
      });
      var isOpenAIClick = Boolean(candidate.oppref || candidate.obref) ||
        String(candidate.utm_source || '').toLowerCase() === 'openai';
      if (!isOpenAIClick) return current;
      try { window.localStorage.setItem(attributionStorageKey, JSON.stringify(candidate)); } catch (storageError) {}
      return candidate;
    } catch (error) {
      return current;
    }
  }

  var currentAttribution = captureAttribution();

  function sessionReceipt() {
    try {
      return boundedValue(window.sessionStorage.getItem(receiptSessionKey), 4096);
    } catch (error) {
      return '';
    }
  }

  function storeSessionReceipt(receipt) {
    try {
      if (receipt) window.sessionStorage.setItem(receiptSessionKey, receipt);
      else window.sessionStorage.removeItem(receiptSessionKey);
    } catch (error) {}
  }

  function cookieValue(name) {
    var prefix = name + '=';
    var pairs = stringValue(document.cookie).split(';');
    for (var index = 0; index < pairs.length; index += 1) {
      var pair = pairs[index].replace(/^\s+/, '');
      if (pair.indexOf(prefix) !== 0) continue;
      try {
        return decodeURIComponent(pair.slice(prefix.length));
      } catch (error) {
        return ''; // A malformed encoded cookie is not a provider reference.
      }
    }
    return '';
  }

  function queryValue(name) {
    try {
      return new window.URL(window.location.href).searchParams.get(name) || '';
    } catch (error) {
      return '';
    }
  }

  function attributionValue(queryName, cookieName) {
    return boundedValue(queryValue(queryName) || cookieValue(cookieName), 1024);
  }

  function cartReceipt(cart) {
    var attributes = cart && cart.attributes;
    return boundedValue(attributes && attributes[consentAttribute], 4096);
  }

  function readCartForConsent() {
    return window.fetch(config.cartUrl || '/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('Cart read failed');
      return response.json();
    });
  }

  function updateCartReceipt(receipt) {
    var attributes = {};
    attributes[consentAttribute] = receipt || '';
    Object.keys(cartAttributionFields).forEach(function (field) {
      attributes[cartAttributionFields[field]] = receipt && currentAttribution
        ? boundedValue(currentAttribution[field], attributionFields[field])
        : '';
    });
    return window.fetch(cartUpdateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('Cart attribute update failed');
      return response;
    });
  }

  function sha256Hex(rawBody) {
    if (!window.crypto || !window.crypto.subtle || typeof window.crypto.subtle.digest !== 'function') {
      return Promise.reject(new Error('Web Crypto is required'));
    }
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(rawBody)).then(function (digest) {
      return Array.prototype.map.call(new Uint8Array(digest), function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function consentId() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return privacy && typeof privacy.consentId === 'function'
        ? boundedValue(privacy.consentId(), 512)
        : '';
    } catch (error) {
      return '';
    }
  }

  function postConsent(body) {
    var payload = Object.assign({}, body, {
      consentId: consentId(),
      observedAt: new Date().toISOString(),
      noticeVersion: 'starkfeld-cookie-banner-v1',
      method: consentObservationMethod
    });
    var rawBody = JSON.stringify(payload);
    return sha256Hex(rawBody).then(function (digest) {
      var separator = consentEndpoint.indexOf('?') >= 0 ? '&' : '?';
      return window.fetch(consentEndpoint + separator + 'body_sha256=' + encodeURIComponent(digest), {
        method: 'POST',
        credentials: 'omit',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: rawBody
      });
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('Consent receipt request failed');
      return response.json();
    });
  }

  function grantConsentReceipt() {
    if (receiptReady || receiptRequest || !measurementAllowed) return;
    var generation = receiptSyncGeneration + 1;
    receiptSyncGeneration = generation;
    denialSynchronized = false;
    receiptRequest = readCartForConsent().then(function (cart) {
      var cartToken = normalizeCartTokenForConsent(cart && cart.token);
      if (!cartToken) throw new Error('Cart token unavailable');
      var presentedReceipt = cartReceipt(cart) || sessionReceipt();
      var body = { consent: 'granted', cartToken: cartToken };
      if (presentedReceipt) body.receipt = presentedReceipt;
      var oppref = currentReference('oppref');
      var obref = currentReference('obref');
      lastReceiptReferences = JSON.stringify([oppref, obref]);
      if (oppref) body.oppref = oppref;
      if (obref) body.obref = obref;
      return postConsent(body).then(function (result) { if (result && typeof result === 'object') result.__cartToken = cartToken; return result; });
    }).then(function (result) {
      var receipt = boundedValue(result && result.receipt, 4096);
      if (!receipt) throw new Error('Consent receipt missing');
      if (!measurementAllowed || generation !== receiptSyncGeneration) {
        return postConsent({ consent: 'revoked', receipt: receipt, cartToken: result.__cartToken }).catch(function () {});
      }
      return updateCartReceipt(receipt).then(function () {
        if (!measurementAllowed || generation !== receiptSyncGeneration) return;
        storeSessionReceipt(receipt);
        receiptReady = true;
      });
    }).catch(function () {
      receiptReady = false;
    }).finally(function () {
      receiptRequest = null;
      if (!desiredConsentState) syncConsentReceipt(false);
    });
  }

  function revokeConsentReceipt() {
    if (denialSynchronized || receiptRequest || !consentEndpoint || typeof window.fetch !== 'function') return;
    receiptSyncGeneration += 1;
    receiptReady = false;
    var knownReceipt = sessionReceipt();
    receiptRequest = readCartForConsent().catch(function () { return null; }).then(function (cart) {
      var receipt = cartReceipt(cart) || knownReceipt;
      var cartToken = normalizeCartTokenForConsent(cart && cart.token);
      var revoked = !receipt;
      var revocation = receipt
        ? postConsent({ consent: 'revoked', receipt: receipt, cartToken: cartToken })
          .then(function () { revoked = true; })
          .catch(function () {})
        : Promise.resolve();
      return revocation.then(function () {
        return updateCartReceipt('').catch(function () {});
      }).then(function () {
        if (revoked) {
          storeSessionReceipt('');
          denialSynchronized = true;
        }
      });
    }).finally(function () {
      receiptRequest = null;
      if (desiredConsentState) syncConsentReceipt(true);
    });
  }

  function syncConsentReceipt(allowed) {
    desiredConsentState = allowed === true;
    if (!consentEndpoint || typeof window.fetch !== 'function' ||
        (window.Shopify && window.Shopify.designMode)) return;
    if (!allowed) {
      stopReferenceWatch();
      if (receiptSyncTimer) window.clearTimeout(receiptSyncTimer);
      receiptSyncTimer = null;
      revokeConsentReceipt();
      return;
    }
    if (receiptReady || receiptRequest || receiptSyncTimer) return;
    receiptSyncTimer = window.setTimeout(function () {
      receiptSyncTimer = null;
      grantConsentReceipt();
    }, 100);
  }

  function seedCartQuantities() {
    var items = Array.isArray(config.cartItems) ? config.cartItems : [];
    items.forEach(function (item) {
      var id = stringValue(item && item.id);
      if (!id) return;
      cartQuantities[id] = (cartQuantities[id] || 0) + positiveQuantity(item.quantity);
    });
  }

  function measure(eventName, data) {
    if (!measurementAllowed || typeof window.oaiq !== 'function') return false;
    window.oaiq('measure', eventName, data);
    return true;
  }

  function pagePayload() {
    var page = config.page || {};
    return {
      type: 'contents',
      contents: [{
        id: stringValue(page.id || (window.location && window.location.pathname)),
        name: stringValue(page.name || document.title),
        content_type: 'page',
        quantity: 1
      }]
    };
  }

  function productPayload() {
    var product = config.product;
    if (!product || !stringValue(product.id)) return null;
    var amount = toInteger(product.amount, null);
    var content = {
      id: stringValue(product.id),
      name: stringValue(product.name),
      content_type: 'product',
      quantity: 1
    };
    var payload = { type: 'contents', contents: [content] };
    if (amount !== null && amount >= 0 && currency) {
      content.amount = amount;
      content.currency = currency;
      payload.amount = amount;
      payload.currency = currency;
    }
    return payload;
  }

  function sendInitialEvents() {
    if (!measurementAllowed || initialEventsSent) return;
    initialEventsSent = true;
    measure('page_viewed', pagePayload());
    var product = productPayload();
    if (product) measure('contents_viewed', product);
  }

  function normalizeCartLine(raw, quantityOverride) {
    if (!raw || typeof raw !== 'object') return null;
    var id = stringValue(raw.variant_id || raw.id);
    if (!id) return null;
    var amount = toInteger(
      typeof raw.price !== 'undefined' ? raw.price : raw.discounted_price,
      null
    );
    return {
      id: id,
      name: stringValue(raw.product_title || raw.title || raw.variant_title),
      quantity: positiveQuantity(
        typeof quantityOverride === 'undefined' ? raw.quantity : quantityOverride
      ),
      amount: amount !== null && amount >= 0 ? amount : null
    };
  }

  function itemsAddedPayload(lines) {
    var contents = [];
    var total = 0;
    var everyItemHasAmount = !!lines.length && !!currency;

    lines.forEach(function (line) {
      if (!line) return;
      var content = {
        id: line.id,
        name: line.name,
        content_type: 'product',
        quantity: line.quantity
      };
      if (line.amount !== null && currency) {
        content.amount = line.amount;
        content.currency = currency;
        total += line.amount * line.quantity;
      } else {
        everyItemHasAmount = false;
      }
      contents.push(content);
    });

    var payload = { type: 'contents' };
    if (contents.length) payload.contents = contents;
    if (everyItemHasAmount && contents.length) {
      payload.amount = total;
      payload.currency = currency;
    }
    return payload;
  }

  function clearPendingAddition() {
    try {
      window.sessionStorage.removeItem(pendingAddKey);
    } catch (error) {}
  }

  function invalidatePendingVerification() {
    pendingVerificationSequence += 1;
  }

  function readPendingAddition() {
    try {
      var raw = window.sessionStorage.getItem(pendingAddKey);
      if (!raw) return null;
      var pending = JSON.parse(raw);
      if (!pending || !Array.isArray(pending.items)) {
        clearPendingAddition();
        return null;
      }
      if (Date.now() - toInteger(pending.createdAt, 0) > pendingAddTtlMs) {
        clearPendingAddition();
        return null;
      }
      return pending;
    } catch (error) {
      clearPendingAddition();
      return null;
    }
  }

  function combineItems(items) {
    var combined = {};
    items.forEach(function (item) {
      var id = stringValue(item && item.id);
      if (!id) return;
      if (!combined[id]) combined[id] = { id: id, quantity: 0 };
      combined[id].quantity += positiveQuantity(item.quantity);
    });
    return Object.keys(combined).map(function (id) { return combined[id]; });
  }

  function storePendingAddition(items) {
    if (!measurementAllowed) return;
    var combined = combineItems(items);
    if (!combined.length) return;
    invalidatePendingVerification();
    var pending = {
      createdAt: Date.now(),
      items: combined.map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity,
          beforeQuantity: cartQuantities[item.id] || 0
        };
      })
    };
    try {
      window.sessionStorage.setItem(pendingAddKey, JSON.stringify(pending));
    } catch (error) {}
  }

  function cartQuantity(cart, variantId) {
    var total = 0;
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    items.forEach(function (item) {
      if (stringValue(item && (item.variant_id || item.id)) === variantId) {
        total += positiveQuantity(item.quantity);
      }
    });
    return total;
  }

  function matchingCartLine(cart, variantId) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    for (var index = 0; index < items.length; index += 1) {
      if (stringValue(items[index] && (items[index].variant_id || items[index].id)) === variantId) {
        return items[index];
      }
    }
    return null;
  }

  function verifyPendingAddition() {
    if (!measurementAllowed || pendingVerification || typeof window.fetch !== 'function') return;
    var pending = readPendingAddition();
    if (!pending) return;
    var verificationSequence = pendingVerificationSequence + 1;
    pendingVerificationSequence = verificationSequence;
    pendingVerification = true;

    window.fetch(config.cartUrl || '/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('Cart read failed');
      return response.json();
    }).then(function (cart) {
      if (!measurementAllowed || verificationSequence !== pendingVerificationSequence) return;
      var confirmed = pending.items.every(function (item) {
        return cartQuantity(cart, item.id) === item.beforeQuantity + item.quantity;
      });
      clearPendingAddition();
      if (!confirmed) return;

      var lines = pending.items.map(function (item) {
        return normalizeCartLine(matchingCartLine(cart, item.id), item.quantity);
      }).filter(Boolean);
      if (lines.length !== pending.items.length) return;
      if (measure('items_added', itemsAddedPayload(lines))) {
        lines.forEach(function (line) {
          cartQuantities[line.id] = cartQuantity(cart, line.id);
        });
      }
    }).catch(function () {
      // Keep the short-lived pending record so a later consent/API retry can verify it.
    }).finally(function () {
      pendingVerification = false;
    });
  }

  function normalizeAjaxAddition(event) {
    var product = event && event.detail && event.detail.product;
    if (!product) return [];
    var rawItems = Array.isArray(product.items) ? product.items : [product];
    return rawItems.map(function (item) { return normalizeCartLine(item); }).filter(Boolean);
  }

  function onAjaxProductAdded(event) {
    if (!measurementAllowed) return;
    var lines = normalizeAjaxAddition(event);
    invalidatePendingVerification();
    clearPendingAddition();
    if (measure('items_added', itemsAddedPayload(lines))) {
      lines.forEach(function (line) {
        cartQuantities[line.id] = (cartQuantities[line.id] || 0) + line.quantity;
      });
    }
  }

  function isCartAddForm(form) {
    if (!form || !form.action) return false;
    try {
      var path = new window.URL(form.action, window.location.href).pathname;
      return /\/cart\/add(?:\.js)?$/.test(path);
    } catch (error) {
      return /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(form.action));
    }
  }

  function formAdditionItems(form) {
    if (!window.FormData) return [];
    try {
      var formData = new window.FormData(form);
      var items = [];
      var simpleId = formData.get('id');
      if (simpleId) {
        items.push({ id: simpleId, quantity: formData.get('quantity') || 1 });
      }
      var indexedItems = {};
      formData.forEach(function (value, key) {
        var match = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(key);
        if (!match) return;
        indexedItems[match[1]] = indexedItems[match[1]] || {};
        indexedItems[match[1]][match[2]] = value;
      });
      Object.keys(indexedItems).forEach(function (index) {
        if (indexedItems[index].id) items.push(indexedItems[index]);
      });
      return items;
    } catch (error) {
      return [];
    }
  }

  function bundleAdditionItems(target) {
    if (!target || typeof target.closest !== 'function') return [];
    var bundle = target.closest('product-bundle, compact-product-bundle');
    if (!bundle || typeof bundle.querySelectorAll !== 'function') return [];

    if (stringValue(bundle.tagName).toLowerCase() === 'compact-product-bundle') {
      var compactVariants = bundle.querySelectorAll('form[is="product-bundle-form"] [name="id"]');
      return Array.prototype.map.call(compactVariants, function (variant) {
        return { id: variant.value, quantity: 1 };
      });
    }

    var items = [];
    var variants = bundle.querySelectorAll('[data-product-bundle-variant][data-variant-id]:not([available])');
    Array.prototype.forEach.call(variants, function (variant) {
      var quantityInput = variant.querySelector('quantity-input input, input[name="quantity"]');
      items.push({
        id: variant.getAttribute('data-variant-id'),
        quantity: quantityInput ? quantityInput.value : 1
      });
    });
    return items;
  }

  function isCheckoutControl(control) {
    if (!control) return false;
    var name = typeof control.getAttribute === 'function' ? control.getAttribute('name') : control.name;
    return name === 'checkout' && !control.disabled;
  }

  function formDataHas(formData, key) {
    if (formData && typeof formData.has === 'function') return formData.has(key);
    var found = false;
    if (formData && typeof formData.forEach === 'function') {
      formData.forEach(function (value, entryKey) {
        if (entryKey === key) found = true;
      });
    }
    return found;
  }

  function isDirectCheckoutForm(form) {
    if (!form || typeof form.matches !== 'function' || !form.matches('form[data-type="add-to-cart-form"]')) {
      return false;
    }
    if (typeof form.querySelector !== 'function' || form.querySelector('[name^="properties["]')) return false;
    try {
      var formData = new window.FormData(form);
      var customBuybox = formDataHas(formData, 'sf_items') ||
        formDataHas(formData, 'sf_discount') ||
        formDataHas(formData, 'bundles');
      if (!customBuybox && typeof document.querySelector === 'function') {
        customBuybox = !!document.querySelector('[data-sf-offer-items],[data-sf-bundle-block]');
      }
      var idInput = form.querySelector('[name="id"]');
      return customBuybox && !!(idInput && idInput.value);
    } catch (error) {
      return false;
    }
  }

  function sendCheckoutStarted() {
    if (!measurementAllowed || checkoutStartedSent) return;
    checkoutStartedSent = measure('checkout_started', { type: 'contents' });
  }

  function onClick(event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return;
    var checkoutControl = target.closest('button[name="checkout"], input[name="checkout"]');
    if (isCheckoutControl(checkoutControl)) lastCheckoutClickAt = Date.now();

    var bundleSubmit = target.closest(
      'product-bundle [data-product-bundle-submit], compact-product-bundle [data-product-bundle-submit]'
    );
    if (bundleSubmit) storePendingAddition(bundleAdditionItems(bundleSubmit));
  }

  function onSubmit(event) {
    var form = event && event.target;
    var directCheckout = isDirectCheckoutForm(form);
    if (isCartAddForm(form)) storePendingAddition(formAdditionItems(form));

    var submitter = event && event.submitter;
    var checkoutFallback = !submitter && Date.now() - lastCheckoutClickAt < 1500;
    if (directCheckout || isCheckoutControl(submitter) || checkoutFallback) sendCheckoutStarted();
  }

  function setConsent(allowed, sourceIsAuthoritative) {
    var next = allowed === true;
    var changed = measurementAllowed !== next;
    measurementAllowed = next;
    if (changed && typeof window.oaiq === 'function') window.oaiq('consent', next);
    if (!next && sourceIsAuthoritative) {
      invalidatePendingVerification();
      clearPendingAddition();
    }
    if (next) {
      sendInitialEvents();
      verifyPendingAddition();
    }
    if (sourceIsAuthoritative) syncConsentReceipt(next);
    return measurementAllowed;
  }

  function syncConsent() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.marketingAllowed !== 'function') return false;
      setConsent(privacy.marketingAllowed() === true, true);
      return true;
    } catch (error) {
      return false;
    }
  }

  seedCartQuantities();

  window.sfOpenAIAds = {
    version: '1.1.0',
    setConsent: function (allowed) { consentObservationMethod = 'visitor_interaction'; return setConsent(allowed, true); },
    syncConsent: syncConsent,
    isAllowed: function () { return measurementAllowed; }
  };

  document.addEventListener('visitorConsentCollected', function () { window.setTimeout(watchPixelReferences, 0); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') watchPixelReferences(); });
  window.addEventListener('pageshow', watchPixelReferences);
  window.addEventListener('load', watchPixelReferences);
  window.setTimeout(watchPixelReferences, 1000);

  document.addEventListener('visitorConsentCollected', function () {
    consentObservationMethod = 'visitor_interaction';
    syncConsent();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') syncConsent();
  });
  document.addEventListener('ajaxProduct:added', onAjaxProductAdded);
  document.addEventListener('click', onClick, true);
  document.addEventListener('submit', onSubmit, true);
  window.addEventListener('load', syncConsent);
  window.addEventListener('pageshow', syncConsent);
  syncConsent();
})(window, document);
